import React, { useState } from 'react';
import { Container, Form, Button, Card, Alert } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import apiClient, { API_ENDPOINTS } from '../utils/api';
import { DEMO_CONFIG, isDemoMode } from '../utils/demo';

function Login({ setIsAuthenticated }) {
  const [username, setUsername] = useState(isDemoMode() ? DEMO_CONFIG.username : '');
  const [password, setPassword] = useState(isDemoMode() ? DEMO_CONFIG.password : '');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await apiClient.post(
        API_ENDPOINTS.LOGIN,
        new URLSearchParams({
          username: username,
          password: password
        }),
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }
      );

      localStorage.setItem('token', response.data.access_token);
      setIsAuthenticated(true);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.detail || 'ログインに失敗しました');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="d-flex align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
      <Card style={{ width: '100%', maxWidth: '440px' }}>
        <Card.Body>
          <Card.Title className="text-center mb-4">宿泊管理システム</Card.Title>

          {error && <Alert variant="danger">{error}</Alert>}

          <Form onSubmit={handleLogin}>
            <Form.Group className="mb-3">
              <Form.Label>ユーザー名</Form.Label>
              <Form.Control
                type="text"
                placeholder="ユーザー名を入力"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>パスワード</Form.Label>
              <Form.Control
                type="password"
                placeholder="パスワードを入力"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </Form.Group>

            <Button
              variant="primary"
              type="submit"
              className="w-100"
              disabled={loading}
            >
              {loading ? 'ログイン中...' : 'ログイン'}
            </Button>
          </Form>

          <p className="text-center mt-3">
            {isDemoMode() ? (
              <>導入をご検討の方は <a href={DEMO_CONFIG.contactUrl} target="_blank" rel="noopener noreferrer">お問い合わせ</a></>
            ) : (
              <>アカウントをお持ちでない場合は <a href="/register">登録</a></>
            )}
          </p>
        </Card.Body>
      </Card>
    </Container>
  );
}

export default Login;
